// DataGrid 오버레이(빈 상태 등) 공용 컴포넌트.

import React from "react";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";

export interface NoRowsOverlayProps {
  message?: string;
  hint?: string;
}

// DataGrid의 noRowsOverlay 슬롯용 빈 상태
export const NoRowsOverlay: React.FC<NoRowsOverlayProps> = ({
  message = "조건에 맞는 데이터가 없습니다.",
  hint = "검색 조건을 조정해 보세요.",
}) => (
  <Stack
    alignItems="center"
    justifyContent="center"
    spacing={1}
    sx={{ height: "100%", py: 4, color: "text.disabled" }}
  >
    <InboxOutlinedIcon sx={{ fontSize: 44 }} />
    <Typography variant="body2" sx={{ color: "text.secondary", fontWeight: 600 }}>
      {message}
    </Typography>
    <Typography variant="caption" sx={{ color: "text.disabled" }}>
      {hint}
    </Typography>
  </Stack>
);
